import Error from 'components/DriverMap/Error/styled';

export default Error;
